<template>
  <div>
    <select-delivery-method-component formAction="forcechallenge/selectphones" cancelLink="forcechallenge/cancel" />
  </div>
</template>
<style>
</style>


<script>
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import Vue from 'vue';
  import SelectDeliveryMethod from '../../SignIn/components/select-delivery-method';

  Vue.component('select-delivery-method-component', SelectDeliveryMethod);

  export default {
    mixins: [
      validation
    ],

    methods: {
      async loginCancel(path) {
        let response = await this.$http.post(path);
        redirectHandler.checkAndRedirect(response, this.$router);
      }
    }

  };
</script>
